import { Link } from "react-router-dom";
import { Attribution } from "./Attribution";

export const ChairCard = ({ chair, index = 0 }) => (
  <Link
    to={`/chair/${chair.slug}`}
    className="group block reveal"
    style={{ animationDelay: `${Math.min(index * 60, 480)}ms` }}
    data-testid={`chair-card-${chair.slug}`}
  >
    <div className="hover-zoom relative border border-border bg-card aspect-[4/5]">
      <img
        src={chair.image_url}
        alt={chair.title}
        loading="lazy"
        className="w-full h-full object-cover"
      />
      <div className="absolute inset-x-0 bottom-0 p-4 opacity-0 group-hover:opacity-100 translate-y-2 group-hover:translate-y-0 bg-gradient-to-t from-black/70 to-transparent transition-[opacity,transform] duration-500">
        <p className="text-white/90 text-xs tracking-wide">{chair.designer}</p>
        <p className="text-white/70 text-xs">{chair.year} · {chair.movement}</p>
      </div>
    </div>
    <div className="pt-3">
      <p className="overline">{chair.era}</p>
      <h3 className="serif text-xl leading-tight mt-1 group-hover:text-accent transition-colors">
        {chair.title}
      </h3>
      <p className="text-sm text-muted-foreground mt-0.5">{chair.designer}</p>
      <Attribution chair={chair} className="mt-2" linked={false} />
    </div>
  </Link>
);
